import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { deleteMaterial, getMaterialById } from "../../../api/materialService";
import { getErrorMessage } from "../../../utils/errorHandler"
import StatusBadge from "../../Shared/StatusBadge";
import RecordActions from "../../Shared/RecordActions";
import FullPageLoader from "../../../common/FullPageLoader";

export default function ViewMaterial() {
  const location = useLocation();
  const navigate = useNavigate();
  const { id: routeId } = useParams();
  const id = location?.state?.materialId || routeId;
  const [material, setMaterial] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchMaterial = async () => {
    try {
      setLoading(true);

      const response = await getMaterialById(id);

      setMaterial(response?.data || response);
    } catch (error) {
      console.error("Error fetching material:", error);
      alert(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchMaterial();
    }
  }, [id]);

  if (loading) {
    return <FullPageLoader text="Loading material..." />;
  }

  if (!material) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body text-center py-4">
            Material not found
          </div>
        </div>
      </div>
    );
  }

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this material?")) return;

    try {
      await deleteMaterial(id);
      navigate("/material");
    } catch (error) {
      alert(getErrorMessage(error));
    }
  };

  return (
    <div className="container-fluid p-4">
        <div className="card p-3 d-flex justify-content-between">
          <RecordActions
            onBack={() => navigate("/material")}
            onEdit={() =>
              navigate(`/material/edit/${material.name}`, {
                state: { materialId: id },
              })
            }
            onDelete={handleDelete}
          />

          <div className="row g-3">
            <div className="col-md-4">
              <span className="fw-bold">Material Name : </span>
              
                {material.name}
            
            </div>

            <div className="col-md-4">
              <span className="fw-bold">Material Value : </span>
                {material.value || "N/A"}
            </div>

            <div className="col-md-4">
              <span className="fw-bold">Status : </span>
                <StatusBadge status={material.status} />
            </div>
          </div>
        </div>
    </div>
  );
}
